var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Dark / Done") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Dark-/-Done",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(2.000000, 2.000000)",
    stroke: "#36B37E",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,9.08563461 L20,10.0055738 C19.9974678,14.4339671 17.0823022,18.3332366 12.8353726,19.5888417 C8.58844308,20.8444467 4.02143865,19.1572813 1.611007,15.442281 C-0.799424659,11.7272806 -0.479078742,6.86942 2.39832388,3.50307557 C5.27572651,0.136731132 10.0247408,-0.936178012 14.0700167,0.86617763",
    id: "Icon-Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Icon-Path",
    points: "20 2 10 12 7 9.002997"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneCheck);
export default __webpack_public_path__ + "static/media/done-check.974c34739f61a792f7e0fadb53d29f08.svg";
export { ForwardRef as ReactComponent };